import styled from '@emotion/styled';

const FooterContainer = styled.div`
  max-width: 1600px;
  margin: 0 auto;
  padding: 4rem 0 2rem;

  .footer__logo {
    max-width: 310px;
    flex-shrink: 0;
    margin: 0 3rem 0 0;
  }

  .footer__misc {
    max-width: 75%;
  }

  .footer__row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .footer__links {
    padding: 0 0 1.5rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .footer__link {
    color: var(--gray);
    text-decoration: none;
    font-weight: 600;
    transition: color ease-in 0.1s;

    &:visited {
      color: var(--gray);
    }

    &:hover {
      color: var(--dark-gray);
    }
  }

  .footer__legal {
    text-align: center;
    font-size: 0.7rem;
    font-weight: 500;
    color: var(--orange);

    a {
      font-weight: 900;
      color: var(--orange);

      &:visited {
        color: var(--orange);
      }

      &:hover {
        text-decoration: none;
      }
    }
  }

  @media screen and (max-width: 1664px) {
    padding: 4rem 2rem 2rem;
  }

  @media screen and (max-width: 1152px) {
    padding: 2rem;

    .footer__logo {
      margin: 0 0 2rem;
      align-self: center;
    }

    .footer__row {
      flex-direction: column;
    }

    .footer__links {
      flex-wrap: wrap;
    }

    .footer__link {
      width: 50%;
      margin: 0 0 1rem;
    }

    .footer__misc {
      max-width: 100%;
    }
  }
`;

export { FooterContainer };
